import Section from '../ui/Section';
import styles from './Brands.module.css';

const brands = [
  'AT&T',
  'Boost Mobile',
  'CrossRoads Nissan',
  'Spectrum TV',
  'MyComputerCareer',
  'Black College Homecoming',
  'Tropical Smoothie',
  'Muzikone Headphones',
  'Bimb\u00e9 Festival'
];

const socials = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/iambriandawson/?hl=en',
    icon: (
      <>
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="4.5" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </>
    )
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/iambriandawson/',
    icon: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@briandawsonmuisc',
    icon: <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  }
];

export default function Brands() {
  return (
    <Section id="influencer" eyebrow="Influencer" title="Brand ambassador for local and national clients.">
      <p>
        Brian has several past and present brand ambassador relationships and an enormous reach of
        over 80k across various platforms such as Facebook, Instagram and Twitter. With two decades
        of experience and an elite educational background, coupled with a vibrant personality and
        positive attitude, Brian is a seasoned individual who will continue to influence the
        entertainment industry on a variety of different levels.
      </p>
      <div className={styles.reach}>
        <span className={styles.reachNumber}>80K+</span>
        <span className={styles.reachLabel}>combined audience reach</span>
      </div>
      <div className={styles.chips}>
        {brands.map((brand) => (
          <span key={brand} className={styles.chip}>{brand}</span>
        ))}
      </div>
      <div className={styles.socials}>
        {socials.map((s) => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Brian Dawson on ${s.label}`}
            className={styles.socialLink}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22" aria-hidden="true">
              {s.icon}
            </svg>
            <span className={styles.socialLabel}>{s.label}</span>
          </a>
        ))}
      </div>
    </Section>
  );
}
